<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ngn9Wa/tc-custom/9781488049835.jpg?1728851595551" alt="This image is the cover for the book Ones We Trust"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ones We Trust
      </h1>
      <p class="bookDescription body article font2">
        <b>From the bestselling author of <i>The Personal Assistant</i> comes a riveting exploration of grief and guilt in the wake of one family’s shocking loss.</b><br/><br/>When former DC journalist Abigail Wolff attempts to rehabilitate her career, she finds herself at the heart of a shocking conspiracy involving the death of a soldier in Afghanistan. This loss has unspeakable emotional consequences for the family and as news of what happened comes to light, Abigail will stop at nothing to write the story.<br/><br/>As she stumbles upon more and more evidence in the case, it seems there are fewer and fewer people she can trust . . . including her own father, a retired army general. Stunned by the revelations, she is equally surprised to find herself falling for the slain soldier’s brother, Gabe, a bitter man struggling to hold his family together. Her investigation eventually leads her to an impossible choice, one of unrelenting sacrifice to protect those she loves.<br/><br/>Beyond the buried truths and betrayals, questions of family loyalty and redemption, Abigail’s search is, most of all, a desperate grasp to carry on—and seek hope in the impossible. In this emotionally gripping story, Kimberly Belle has penned an unforgettable narrative and a true testament to the meaning of trust.<br/><br/>“<i>The Ones We Trust</i> is an emotionally moving, captivating story that is a perfect book club pick.” —<i>RT Book Reviews</i><br/><br/>“The twists and turns kept me guessing and changing my mind until the end . . . This is an excellent story that captures the way two families can have their lives changed by one event.” —<i>Coastal Breeze News</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kimberly Belle
      </h2>
      
      <p class="authorDescription body article">Kimberly Belle is the <I>USA Today</I> and internationally bestselling author of five novels of suspense. Her third, <I>The Marriage Lie</I>, was a semifinalist in the 2017 Goodreads Choice Awards for Best Mystery &amp; Thriller, and has been translated into a dozen languages. Before turning to fiction, Kimberly worked in marketing and nonprofit fundraising.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93db9632